import * as React from 'react';
import { isEqual } from 'lodash';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { isStringEmpty } from '../../../../util/string/is-string-empty.util';
import { Label } from '@atlaskit/field-base';
import { BlockColorEnum } from '../../../../enum/block-color.enum';
import { FormFieldSelectable } from './form-field-selectable';

const CheckableWrapper = styled.div`
  display:flex;
  align-items: center;
  margin-top: 15px;
`;

interface ICheckableFieldItem {
  value: any;
  label: string;
}

interface ICheckableFieldProps {
  value: any;
  name: string;
  disabled: boolean;
  items: ICheckableFieldItem[];
  onChange: (newValue: any, clickedField: any) => void;
  onBlur: () => void;
  isInvalid: boolean;
  onTextClicked?: (value: any) => void;
  type: 'radio' | 'checkbox';
  label?: string;
  labelColor?: string;
}

const CheckableFieldContainer = styled.div`
  & label div {
    color: ${(props: { labelColor: string }) => props.labelColor ? props.labelColor : BlockColorEnum.PrimaryTextColor};
    font-size: 16px;
  }
`;

@observer
export class CheckableField extends React.Component<ICheckableFieldProps> {
  onChange = (value: string) => () => {
    const props = this.props;
    props.onChange(props.type === 'checkbox' && isEqual(value, props.value) ? undefined : value, value);
  }

  render() {
    const props = this.props;
    return (
      <CheckableFieldContainer labelColor={props.labelColor}>
        {isStringEmpty(props.label) ? null : <Label
          isRequired={true}
          htmlFor={props.name}
          label={props.label}
        />}
        {props.items.map((item) => {
          return <CheckableWrapper key={item.value}>
            <FormFieldSelectable
              {...props}
              onChange={this.onChange(item.value)}
              label={item.label}
              value={isEqual(props.value, item.value)}
              onClick={() => {
                if (props.onTextClicked) {
                  props.onTextClicked(item.value);
                } else {
                  this.onChange(item.value)();
                }
              }}
            />
          </CheckableWrapper>;
        })}
      </CheckableFieldContainer>
    );
  }
}
